import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EngageCardCtaImgComponent } from '@web/shared/ui';
import { RouterLink } from '@angular/router';

@Component({
	selector: 'uc-directory-card-cta',
	imports: [CommonModule, EngageCardCtaImgComponent, RouterLink],
	templateUrl: './directory-card-cta.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DirectoryCardCtaComponent {
	slug = input('/directory');
	cardTitle = input('Directory');
	cardDesc = input('Looking for more? Discover the A-Z of subjects in the directory.');
	buttonText = input('View All Subjects');
}
